@if (surface) {
  <div>
    <div class="table-surface col-3">
      <table class="table table-striped table-smaller table-not-rounded">
        <caption class="caption-sm caption-rounded">
          <div class="row">
            <div class="col-md-12">{{lgTrad.SURFACES}}</div>
          </div>
        </caption>
        <thead>
          <tr class="surface-titre">
            <th>&nbsp;</th>
          </tr>
          <tr>
            <th>{{lgTrad.TYPE}}</th>
          </tr>
        </thead>
        <tbody>
          @for (rf of surface.RFSURFACES; track rf) {
            <tr>
              <ng-container>
                @if (checkTabulation(rf) === 0) {
                  <td>{{rf.LBLSURFACE}}</td>
                }
                @if (checkTabulation(rf) === 1) {
                  <td class="pl-10px">{{rf.LBLSURFACE}}
                  </td>
                }
                @if (checkTabulation(rf) === 2) {
                  <td class="pl-15px">{{rf.LBLSURFACE}}
                  </td>
                }
                @if (checkTabulation(rf) === 3) {
                  <td class="pl-20px">{{rf.LBLSURFACE}}
                  </td>
                }
              </ng-container>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="table-surface col-3">
      <table class="table table-striped table-smaller table-not-rounded">
        <caption class="caption-sm caption-rounded">
          <div class="row">
            <div class="col-md-9">{{surface.SURFACEA.RFMILLESIME.MILLESIME}}</div>
            <div class="col-md-3 text-right">
              @if (droitsAccess.write && !surface.SURFACEA.RFMILLESIME.FINSAIS) {
                <add-button class="pr-2 tab-btn-roundadd" (click)="openSurface('A')"
                  />
              }
            </div>
          </div>
        </caption>
        <thead>
          <tr class="surface-titre">
            <th colspan="2">{{lgTrad.TOTAL}}</th>
            <th colspan="2">{{lgTrad.ATELIERLAIT}}</th>
          </tr>
          <tr class="surface-annee">
            <th>Surf</th>
            <th>Rend</th>
            <th>Surf</th>
            <th>Rend</th>
          </tr>
        </thead>
        <tbody>
          @for (surf of surface.SURFACEA.SURFACES; track surf; let index = $index) {
            <tr class="surface-annee">
              <ng-container>
                <td class="text-right">{{getData(surf.SURFTOTAL)}}</td>
                <td class="text-right">{{(checkRfSurfaceRendement(index)) ? getData(surf.RDTTOTAL) : ''}}</td>
                <td class="text-right">{{getData(surf.SURFLAIT)}}</td>
                <td class="text-right">{{(checkRfSurfaceRendement(index)) ? getData(surf.RDTLAIT) : ''}}</td>
              </ng-container>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="table-surface col-3">
      <table class="table table-striped table-smaller table-not-rounded">
        <caption class="caption-sm caption-rounded">
          <div class="row">
            <div class="col-md-9">{{surface.SURFACEB.RFMILLESIME.MILLESIME}}</div>
            <div class="col-md-3 text-right">
              @if (droitsAccess.write && !surface.SURFACEB.RFMILLESIME.FINSAIS) {
                <add-button class="pr-2 tab-btn-roundadd" (click)="openSurface('B')"
                  />
              }
            </div>
          </div>
        </caption>
        <thead>
          <tr class="surface-titre">
            <th colspan="2">{{lgTrad.TOTAL}}</th>
            <th colspan="2">{{lgTrad.ATELIERLAIT}}</th>
          </tr>
          <tr class="surface-annee">
            <th>Surf</th>
            <th>Rend</th>
            <th>Surf</th>
            <th>Rend</th>
          </tr>
        </thead>
        <tbody>
          @for (surf of surface.SURFACEB.SURFACES; track surf; let index = $index) {
            <tr class="surface-annee">
              <ng-container>
                <td class="text-right">{{getData(surf.SURFTOTAL)}}</td>
                <td class="text-right">{{(checkRfSurfaceRendement(index)) ? getData(surf.RDTTOTAL) : ''}}</td>
                <td class="text-right">{{getData(surf.SURFLAIT)}}</td>
                <td class="text-right">{{(checkRfSurfaceRendement(index)) ? getData(surf.RDTLAIT) : ''}}</td>
              </ng-container>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="table-surface col-3">
      <table class="table table-striped table-smaller table-not-rounded">
        <caption class="caption-sm caption-rounded">
          <div class="row">
            <div class="col-md-9">{{surface.SURFACEC.RFMILLESIME.MILLESIME}}</div>
            <div class="col-md-3 text-right">
              @if (droitsAccess.write && !surface.SURFACEC.RFMILLESIME.FINSAIS) {
                <add-button class="pr-2 tab-btn-roundadd" (click)="openSurface('C')"
                  />
              }
            </div>
          </div>
        </caption>
        <thead>
          <tr class="surface-titre">
            <th colspan="2">{{lgTrad.TOTAL}}</th>
            <th colspan="2">{{lgTrad.ATELIERLAIT}}</th>
          </tr>
          <tr class="surface-annee">
            <th>Surf</th>
            <th>Rend</th>
            <th>Surf</th>
            <th>Rend</th>
          </tr>
        </thead>
        <tbody>
          @for (surf of surface.SURFACEC.SURFACES; track surf; let index = $index) {
            <tr class="surface-annee">
              <ng-container>
                <td class="text-right">{{getData(surf.SURFTOTAL)}}</td>
                <td class="text-right">{{(checkRfSurfaceRendement(index)) ? getData(surf.RDTTOTAL) : ''}}</td>
                <td class="text-right">{{getData(surf.SURFLAIT)}}</td>
                <td class="text-right">{{(checkRfSurfaceRendement(index)) ? getData(surf.RDTLAIT) : ''}}</td>
              </ng-container>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
}